<template>
  <div class="content">
    <div class="wrap">
      <div class="content-top">
        <el-page-header @back="goBack">
          <div slot="content" style="font-size: 16px ;color: #909399;">{{name}}预警记录</div>
        </el-page-header>
        
        <div class="content-top-right">
          <p>
            <span>日期</span>
            <el-date-picker
              v-model="createTime"
              size="mini"
              type="date"
              clearable
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </p>

          <p style="margin: 0 10px 0 40px;">
            <span>名称</span>
            <el-input v-model="alarmName" placeholder="请输入预警类型" size="mini" clearable></el-input>
          </p>
          <span class="button" @click="select">查询</span>
        </div>
      </div>

      <div class="table">
        <el-table :data="tableData" stripe height="100%">
          <el-table-column label="序号" prop="index" width="80"></el-table-column>
          <el-table-column label="预警类型" prop="alarmName"></el-table-column>
          <el-table-column label="预警数值" prop="alarmValue"></el-table-column>
          <el-table-column label="预警时间" prop="createDate"></el-table-column>
        </el-table>
      </div>

      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  import base from '../../../untils/base'
  export default {
    data() {
      return {
        id: '',
        name: '',
        pageSize: 20,
        pageNum: 1,
        total: 0,
        alarmName: '',
        createTime: '',
        tableData: [],
      }
    },

    created() {
      const {id, name} = this.$route.query
      this.id = id
      this.name = name
      this.getData()
    },

    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        this.getData()
      },

      handleCurrentChange(val) {
        this.pageNum = val
        this.getData()
      },

      select() {
        this.pageSize = 20
        this.pageNum = 1
        this.getData()
      },

      getData() {
        myHttp.selectEquipGantryAlarmDetailPage({
          gantryId: this.id,
          alarmName: this.alarmName,
          createTime: this.createTime,
          pageSize: this.pageSize,
          pageNum: this.pageNum
        }).then(res => {
          console.log(res);
          if(res.data.code === 200) {
            const list = res.data.data.pageInfo.list
            list.forEach((item, index) => {
              item.index = (this.pageNum - 1) * this.pageSize + 1 + index
            })
            this.tableData = list
            this.total = res.data.data.pageInfo.total
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },

      goBack(){
        this.$router.go(-1)
      }
    },
  }
</script>

<style scoped>
.wrap {
  height: 100%;
  border-radius: 6px;
  background-color: #fff;
}
.content-top {
  display: flex;
  height: 56px;
  padding: 0 16px;
  border-bottom: 2px solid #D8D8D8;
  align-items: center;
  justify-content: space-between;
}

.button {
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid #999999;
  cursor: pointer;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #666;
}

.button:hover {
  background-color: #4D6EB1;
  color: #fff;
}

.content-top-right {
  display: flex;
  width: 50%;
  align-items: center;
  justify-content: flex-end;
}

.content-top-right p {
  display: flex;
  align-items: center;
}

.content-top-right p span {
  display: inline-block;
  width: 34px;
  font-size: 14px;
  color: #666;
  margin-right: 12px;
}

.content-top-right ::v-deep .el-input--mini {
  width: 10.4167vw;
  height: 32px;
}

.content-top-right ::v-deep .el-input--mini .el-input__inner {
  height: 32px;
  line-height: 32px;
}

.table {
  height: calc(100% - 106px);
}

.pagination {
  height: 50px;
  border-radius: 0px 0px 6px 6px;
  box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
}

.pagination ::v-deep .el-pagination {
  padding: 11px 0 !important;
}
</style>